var React = require('react');

function FeiLogo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M28.3,39.7l15.3,15.5V24.3L28.3,39.7z M0,78.1h25.5V0H0V78.1z M28.3,0l24.3,30.7V0H28.3z","key":0}),React.createElement("path",{"d":"M85.3,78.1h24V43.2L85.3,78.1z M85.3,38.2l14.2,14.6V22.4L85.3,38.2z M57.1,78.1h25.5V0H57.1V78.1z M85.3,0\n\tl24,30.8V0H85.3z","key":1}),React.createElement("rect",{"x":"116.3","y":"0","width":"25","height":"78.1","key":2})]);
}

FeiLogo.defaultProps = {"version":"1.1","id":"Lager_1","x":"0px","y":"0px","viewBox":"0 0 141.3 78.1","style":{"enableBackground":"new 0 0 141.3 78.1"},"xmlSpace":"preserve"};

module.exports = FeiLogo;

FeiLogo.default = FeiLogo;
